module.exports = __webpack_public_path__ + "img/icon_log.181a2c48.svg";